var map = {
	"./adminprofile/edit": [
		1997,
		16
	],
	"./agentprofile/edit": [
		1998,
		19
	],
	"./ai_assistant/edit": [
		1999,
		22
	],
	"./api_key/edit": [
		2000,
		25
	],
	"./canned_answer/edit": [
		2001,
		30
	],
	"./client/edit": [
		2002,
		33
	],
	"./destination_restrictor/edit": [
		2003,
		35
	],
	"./disposition/edit": [
		2004,
		38
	],
	"./field/edit": [
		2005,
		41
	],
	"./form/edit": [
		2006,
		44
	],
	"./form_website/edit": [
		2007,
		47
	],
	"./gdpr/edit": [
		2008,
		49
	],
	"./invoice/edit": [
		2009,
		51
	],
	"./invoice_post/edit": [
		2010,
		54
	],
	"./journey/edit": [
		2011,
		57
	],
	"./journey_draft/edit": [
		2012,
		60
	],
	"./journey_variable/edit": [
		2013,
		64
	],
	"./list/edit": [
		2014,
		67
	],
	"./list_file/edit": [
		2015,
		70
	],
	"./mail_account/edit": [
		2016,
		73
	],
	"./operational_hours/edit": [
		2017,
		76
	],
	"./organization/edit": [
		2018,
		79
	],
	"./pause/edit": [
		2019,
		82
	],
	"./phonenumber_monthly_cost/edit": [
		2020,
		85
	],
	"./phonenumber_monthly_cost_parent/edit": [
		2021,
		88
	],
	"./phonenumber_purchase/edit": [
		2022,
		92
	],
	"./phonenumber_setup_cost/edit": [
		2023,
		95
	],
	"./phonenumber_setup_cost_parent/edit": [
		2024,
		98
	],
	"./points_system/edit": [
		2025,
		102
	],
	"./prepaid_credit/edit": [
		2026,
		105
	],
	"./queue/edit": [
		2027,
		108
	],
	"./signature/edit": [
		2028,
		112
	],
	"./skill/edit": [
		2029,
		115
	],
	"./sla_policy/edit": [
		2030,
		118
	],
	"./sound/edit": [
		2031,
		121
	],
	"./stats_alarm/edit": [
		2032,
		124
	],
	"./stats_custom_metric/edit": [
		2033,
		127
	],
	"./stats_report/edit": [
		2034,
		130
	],
	"./stats_widget/edit": [
		2035,
		133
	],
	"./superadmin_profile/edit": [
		2036,
		136
	],
	"./tag/edit": [
		2037,
		139
	],
	"./tariff/edit": [
		2038,
		142
	],
	"./tariff_parent/edit": [
		2039,
		145
	],
	"./team/edit": [
		2040,
		148
	],
	"./text_message_source/edit": [
		2041,
		6
	],
	"./time_interval/edit": [
		2042,
		152
	],
	"./user/edit": [
		2043,
		155
	],
	"./voice_asterisk/edit": [
		2044,
		158
	],
	"./voice_asterisk_downgrade/edit": [
		2045,
		161
	],
	"./voice_recording_transcript_setting/edit": [
		2046,
		165
	],
	"./voice_route/edit": [
		2047,
		168
	],
	"./voice_shortcut/edit": [
		2048,
		171
	],
	"./voice_trunk/edit": [
		2049,
		174
	],
	"./voice_voicemail/edit": [
		2050,
		177
	],
	"./wallboard/edit": [
		2051,
		180
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1869;
module.exports = webpackAsyncContext;